import { addToCart as addToCartApi, addItemsToCart as addItemsToCartApi } from '../api/cartApi';
import { CartView } from '../types/cartTypes';

export async function addItem(
  productId: string,
  variantId: number,
  custom: Record<string, unknown>,
  quantity = 1,
  externalPrice?: { centAmount: number; currencyCode: string }
): Promise<CartView | null> {
  return addToCartApi(productId, variantId, custom, quantity, externalPrice?.centAmount);
}

export async function addItems(
  items: Array<{
    productId: string;
    variantId: number;
    custom?: Record<string, unknown>;
    quantity?: number;
    externalPrice?: { centAmount: number; currencyCode: string };
  }>
): Promise<CartView | null> {
  return addItemsToCartApi(items.map(i => ({ ...i, externalPrice: i.externalPrice?.centAmount })));
}
